/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const industryAnalyze = process.env.VUE_APP_SERVER_URL

//获取全部行业
export const industriesApi = (data) => Axios.get(industryAnalyze + '/dict/industry/industries', data);

//获取全部国家
export const counterVyContinentIdApi = (data) => Axios.get(industryAnalyze + '/dict/country/countries', data);

// 获取企业列表
export const infosApi = (data) => Axios.get(industryAnalyze + '/ent/infos', data);

